<nb-card>
  <nb-card-header>
    <div class="menu-buttons"></div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div id="print-section" class="print-layout">
      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h4>{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>
              CÔNG NỢ TỔNG HỢP
              {{ mode === "customer" ? "KHÁCH HÀNG" : "NHÀ CUNG CẤP" }}
            </h4>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table class="table-detail">
        <thead>
          <tr style="text-align: center">
            <th>
              <strong> {{ "common.no" | translate }} </strong>
            </th>
            <th>
              <strong>
                {{ mode === "customer" ? "Khách hàng" : "Nhà cung cấp" }}
              </strong>
            </th>
            <th>
              <strong> Điện thoại </strong>
            </th>
            <th>
              <strong> Doanh thu </strong>
            </th>
            <th>
              <strong>Thanh toán</strong>
            </th>
            <th>
              <strong> Còn nợ </strong>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of objects; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.fullName }}</td>
            <td>{{ item.mobile }}</td>
            <td style="text-align: right">
              <label>
                {{ item.saleAmount | number: 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.paidAmount | number: 0 }}
              </label>
            </td>
            <td style="text-align: right">
              {{ item.debitAmount | number: 0 }}
            </td>
          </tr>

          <tr>
            <td colspan="3" style="text-align: right">
              <strong> TỔNG CỘNG: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ saleAmount | number: 0 }} </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ paidAmount | number: 0 }} </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ debitAmount | number: 0 }} </strong>
            </td>
          </tr>
        </tbody>

        <tfoot></tfoot>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td colspan="2" class="height-1"></td>
        </tr>
        <tr>
          <td></td>
          <td style="text-align: center">
            <span>
              Ngày {{ currentDate | date: "dd " }} tháng
              {{ currentDate | date: "MM " }} năm
              {{ currentDate | date: "yyyy " }}</span
            >
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong> Người lập phiếu </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong>Khách hàng </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      *ngIf="!printing"
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
